import { apiFetch } from "./client";

export type InvoiceStatus = "pending" | "paid" | "overdue" | "void";

export type InvoiceItemType =
  | "monthly_fee"
  | "tx_fee_fixed"
  | "tx_fee_percentage"
  | "over_quota_fee"
  | "adjustment";

export interface InvoiceItem {
  id: string;
  type: InvoiceItemType;
  description: string;
  quantity: number;
  unitAmount: string;
  totalAmount: string;
}

export interface Invoice {
  id: string;
  merchantId: string;
  merchantName?: string;
  period: string;
  monthlyFeeAmount: string;
  txFeesAmount: string;
  txCount: number;
  totalAmount: string;
  currency: string;
  status: InvoiceStatus;
  issuedAt: string;
  dueAt: string;
  paidAt: string | null;
  selfBillingIntentId: string | null;
  items: InvoiceItem[];
}

export interface InvoiceList {
  data: Invoice[];
  nextCursor: string | null;
}

export interface GenerateInvoicesInput {
  merchantId?: string;
  period?: string;
}

export interface GenerateInvoicesResult {
  generated: Invoice[];
  skipped: { merchantId: string; reason: string }[];
}

export const listInvoices = (
  params: {
    limit?: number;
    cursor?: string;
    status?: InvoiceStatus;
    period?: string;
    merchantId?: string;
  } = {},
) =>
  apiFetch<InvoiceList>("/admin/invoices", {
    query: {
      limit: params.limit,
      cursor: params.cursor,
      status: params.status,
      period: params.period,
      merchantId: params.merchantId,
    },
  });

export const getInvoice = (id: string) =>
  apiFetch<Invoice>(`/admin/invoices/${id}`);

export const generateInvoices = (body: GenerateInvoicesInput) =>
  apiFetch<GenerateInvoicesResult>("/admin/invoices/generate", {
    method: "POST",
    body,
  });

export const markInvoicePaid = (id: string) =>
  apiFetch<Invoice>(`/admin/invoices/${id}/mark-paid`, { method: "PATCH" });
